import React, { useEffect } from "react";
import { connect } from "react-redux";
import PrecarriersComponent from "./PrecarriersComponent";
import { BrandsManagementsFunction } from "../../redux/index";
import { useParams } from "react-router";
import { EndPoints } from "../../utils/EndPoints";

function PrecarriersContainer(props) {
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    if (props.user.uid) {
      props.BrandsManagementsFunction("get", EndPoints["Precarriers"]);
    }
  };

  const { tab, id } = useParams();
  const params = { tab: tab, id: id };
  return <PrecarriersComponent {...props} params={params} />;
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  [EndPoints["Precarriers"]]: state.modules[EndPoints["Precarriers"]],
  loading: state.modules.loading,
});
const mapDispatchToProps = {
  BrandsManagementsFunction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrecarriersContainer);
